<template>
  <iq-card class="fuel-card h-100 w-100">
    <div class="fms-card-header">
      <div>
        <h4>Fuel Consumption Today</h4>
        <p class="text-muted">Main engine fuel consumption trend over the last 24 hours.</p>
      </div>
      <span class="fms-tag fms-tag--outline">24H Window</span>
    </div>
    <net-main-engine-consumption-chart
      :series="currAssetSummary.series"
      :netConsumption="meEngineConsValue"
      :totalSupply="totalSupply"
      :totalReturn="totalReturn"
      :isSingleMainEngine="isSingleMainEngine"
      :isHaveReturnFlowmeter="deviceStatus.flowmeterType === 'in-out'"
    />
    <div class="fuel-summary">
      <div>
        <h5>Total AE Cons</h5>
        <p>{{ totalAeCons }} <span>Liter</span></p>
      </div>
      <div>
        <h5>Total ME Cons</h5>
        <p>{{ currAssetSummary.fm.meEngineCons }} <span>Liter</span></p>
        <span>Avg ME Flow: {{ avgCombinedFlow }} L/h</span>
      </div>
    </div>
  </iq-card>
</template>

<script>
import NetMainEngineConsumptionChart from '@/components/fms/NetMainEngineConsumptionChart';

export default {
  name: 'FuelConsumptionCard',
  components: {
    NetMainEngineConsumptionChart,
  },
  props: {
    currAsset: {
      type: Object,
      default: null,
    },
    currAssetSummary: {
      type: Object,
      required: true,
    },
    avgCombinedFlow: {
      type: [String, Number],
      default: '-',
    },
    totalAeCons: {
      type: [String, Number],
      default: '-',
    },
    totalEngineCons: {
      type: [String, Number],
      default: '-',
    },
    isSingleMainEngine: {
      type: Boolean,
      default: false,
    },
    deviceStatus: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    meEngineConsValue() {
      const raw = this.currAsset?.summary?.flowmeter?.summary?.meEngineCons;
      return Number.isFinite(Number(raw)) ? Number(raw).toFixed(2) : this.currAssetSummary.fm.meEngineCons;
    },
    totalSupply() {
      if (!this.currAssetSummary?.fm) return '0.00';
      const { fm } = this.currAssetSummary;
      let total = 0;
      if (fm.PORT?.in?.avgFuelFlow) {
        total += parseFloat(fm.PORT.in.avgFuelFlow);
      }
      if (fm.STARBOARD?.in?.avgFuelFlow) {
        total += parseFloat(fm.STARBOARD.in.avgFuelFlow);
      }
      if (fm.CENTER?.in?.avgFuelFlow) {
        total += parseFloat(fm.CENTER.in.avgFuelFlow);
      }
      return total.toFixed(2);
    },
    totalReturn() {
      if (!this.currAssetSummary?.fm) return '0.00';
      const { fm } = this.currAssetSummary;
      let total = 0;
      if (fm.PORT?.out?.avgFuelFlow) {
        total += parseFloat(fm.PORT.out.avgFuelFlow);
      }
      if (fm.STARBOARD?.out?.avgFuelFlow) {
        total += parseFloat(fm.STARBOARD.out.avgFuelFlow);
      }
      if (fm.CENTER?.out?.avgFuelFlow) {
        total += parseFloat(fm.CENTER.out.avgFuelFlow);
      }
      return total.toFixed(2);
    },
  },
};
</script>

<style scoped>
.fuel-card {
  padding: 15px 20px;
}

.fuel-section {
  margin-top: 12px;
  padding: 12px;
  border: 2px solid #E8ECF3;
  border-radius: 20px;
}

.fuel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.fuel-header h5 {
  margin: 0 0 4px;
  font-size: 0.875rem;
}

.fuel-header span {
  font-size: 0.75rem;
  color: #6b7280;
}

.fuel-value {
  text-align: right;
}

.fuel-value strong {
  font-size: 1rem;
  color: #1d2433;
}

.fuel-value span {
  font-size: 0.6875rem;
  color: #6b7280;
}

.fuel-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
}

.fuel-summary div {
  background: #ffffff;
  border: 2px solid #E8ECF3;
  border-radius: 20px;
  padding: 10px 12px;
}

.fuel-summary h5 {
  margin: 0 0 6px;
  font-size: 0.8125rem;
  color: #1d2433;
}

.fuel-summary p {
  margin: 0 0 4px;
  font-size: 0.875rem;
}

.fuel-total {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #edf1f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 991px) {
  .fuel-summary {
    grid-template-columns: 1fr;
  }
}
</style>
